(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbv2-brand-culture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }
    ready(function () {
      var roots = document.querySelectorAll('[data-bbc]');
      if (!roots.length) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.documentElement.classList.add('bbc-story');

      function bootLenis() {
        if (reduce || window.__bbLenis || typeof window.Lenis !== 'function') return;
        var lenis = new window.Lenis({
          lerp: 0.085,
          wheelMultiplier: 0.92,
          touchMultiplier: 1.05,
          smoothWheel: true,
          syncTouch: false,
          autoRaf: false,
          overscroll: true
        });
        window.__bbLenis = lenis;
        function raf(time) {
          lenis.raf(time);
          requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
      }
      if (document.readyState === 'complete') bootLenis();
      else window.addEventListener('load', bootLenis);

      roots.forEach(function (root) {
        var reveals = root.querySelectorAll('[data-bbc-reveal]');
        if (reduce || !('IntersectionObserver' in window)) {
          reveals.forEach(function (el) { el.classList.add('is-in'); });
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            var delay = el.getAttribute('data-bbc-delay');
            if (delay) el.style.transitionDelay = delay;
            el.classList.add('is-in');
            io.unobserve(el);
          });
        }, { threshold: 0.18, rootMargin: '0px 0px -14% 0px' });
        reveals.forEach(function (el) { io.observe(el); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbv2-hero-worlds"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('.bbw').forEach(function (root) {
      function markReady() {
        root.classList.remove('bbw--booting');
        root.classList.add('bbw--ready');
      }

      /* Progressive: visible by default; brief boot only when motion is allowed */
      if (noMotion.matches) {
        markReady();
      } else {
        root.classList.add('bbw--booting');
        root.classList.remove('bbw--ready');
        requestAnimationFrame(function () {
          requestAnimationFrame(markReady);
        });
        setTimeout(markReady, 900);
      }

      root.querySelectorAll('.bbw__panel').forEach(function (panel) {
        var flowerBtn = panel.querySelector('.bbw__flowerBtn');
        var reveal = panel.querySelector('.bbw__reveal');
        var closeBtn = panel.querySelector('.bbw__closeReveal');
        if (!flowerBtn || !reveal) return;

        var scene = panel.querySelector('.bbw__scene');
        var sceneDefault = panel.getAttribute('data-scene-default');
        var sceneActive = panel.getAttribute('data-scene-active');

        function setScene(url) {
          if (!scene || !url) return;
          scene.style.backgroundImage = "url('" + url.replace(/'/g, '%27') + "')";
        }

        function openReveal() {
          panel.classList.add('bbw__panel--revealed');
          flowerBtn.setAttribute('aria-expanded', 'true');
          reveal.removeAttribute('hidden');
          setScene(sceneActive || sceneDefault);
        }
        function closeReveal() {
          panel.classList.remove('bbw__panel--revealed');
          flowerBtn.setAttribute('aria-expanded', 'false');
          reveal.setAttribute('hidden', '');
          setScene(sceneDefault);
        }

        flowerBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openReveal();
        });
        if (closeBtn) closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeReveal();
        });
      });

      if (!fine.matches || noMotion.matches) return;

      var panels = root.querySelectorAll('.bbw__panel');
      var state = [];
      panels.forEach(function (panel) {
        state.push({ panel: panel, tx: 0.5, ty: 0.45, cx: 0.5, cy: 0.45, lx: 0.5, ly: 0.45, active: false });
        panel.addEventListener('pointerenter', function () {
          state.forEach(function (s) { if (s.panel === panel) s.active = true; });
        });
        panel.addEventListener('pointerleave', function () {
          state.forEach(function (s) {
            if (s.panel === panel) {
              s.active = false;
              s.tx = 0.5; s.ty = 0.45;
            }
          });
        });
        panel.addEventListener('pointermove', function (e) {
          var r = panel.getBoundingClientRect();
          state.forEach(function (s) {
            if (s.panel === panel) {
              s.tx = (e.clientX - r.left) / r.width;
              s.ty = (e.clientY - r.top) / r.height;
            }
          });
        });
      });

      function tick() {
        state.forEach(function (s) {
          if (!s.active) {
            s.cx += (0.5 - s.cx) * 0.06;
            s.cy += (0.45 - s.cy) * 0.06;
            s.lx += (0.5 - s.lx) * 0.04;
            s.ly += (0.45 - s.ly) * 0.04;
            s.panel.style.setProperty('--bbw-shift-x', '0');
            s.panel.style.setProperty('--bbw-shift-y', '0');
          } else {
            s.cx += (s.tx - s.cx) * 0.14;
            s.cy += (s.ty - s.cy) * 0.14;
            s.lx += (s.cx - s.lx) * 0.07;
            s.ly += (s.cy - s.ly) * 0.07;
            s.panel.style.setProperty('--bbw-shift-x', (s.tx - 0.5).toFixed(3));
            s.panel.style.setProperty('--bbw-shift-y', (s.ty - 0.5).toFixed(3));
          }
          s.panel.style.setProperty('--bbw-gx', (s.cx * 100).toFixed(1) + '%');
          s.panel.style.setProperty('--bbw-gy', (s.cy * 100).toFixed(1) + '%');
          s.panel.style.setProperty('--bbw-lx', (s.lx * 100).toFixed(1) + '%');
          s.panel.style.setProperty('--bbw-ly', (s.ly * 100).toFixed(1) + '%');
        });
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbv2-split-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }
    ready(function () {
      document.querySelectorAll('[data-bbsh]').forEach(function (root) {
        if (root.getAttribute('data-bbsh-ready') === 'true') return;
        root.setAttribute('data-bbsh-ready', 'true');
        var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bbsh-slide]'));
        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bbsh-goto]'));
        if (!slides.length) return;
        var i = 0;
        var heroVisible = true;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function playVideo(slide, on) {
          var video = slide.querySelector('video');
          if (!video) return;
          var toggle = slide.querySelector('[data-bbsh-video-toggle]');
          if (on && heroVisible && !document.hidden && video.dataset.userPaused !== 'true' && (!reduceMotion || video.dataset.userPlayed === 'true')) {
            if (!video.getAttribute('src')) {
              video.src = video.getAttribute('data-src') || '';
              video.load();
            }
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
          if (toggle) toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        }
        function show(next) {
          i = (next + slides.length) % slides.length;
          slides.forEach(function (slide, n) {
            var on = n === i;
            slide.classList.toggle('is-active', on);
            playVideo(slide, on);
          });
          dots.forEach(function (dot, n) {
            dot.classList.toggle('is-active', n === i);
          });
        }
        root.querySelectorAll('[data-bbsh-dir]').forEach(function (btn) {
          btn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            show(i + (Number(btn.getAttribute('data-bbsh-dir')) || 1));
          });
        });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            show(Number(dot.getAttribute('data-bbsh-goto')) || 0);
          });
        });
        var startX = 0;
        root.addEventListener('touchstart', function (event) {
          if (!event.changedTouches || !event.changedTouches[0]) return;
          startX = event.changedTouches[0].clientX;
        }, { passive: true });
        root.addEventListener('touchend', function (event) {
          if (!event.changedTouches || !event.changedTouches[0]) return;
          var dx = event.changedTouches[0].clientX - startX;
          if (Math.abs(dx) < 48) return;
          show(i + (dx < 0 ? 1 : -1));
        }, { passive: true });
        root.querySelectorAll('[data-bbsh-video-toggle]').forEach(function (toggle) {
          var slide = toggle.closest('[data-bbsh-slide]');
          var video = slide.querySelector('video');
          function syncLabel() { toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel; }
          video.addEventListener('play', syncLabel);
          video.addEventListener('pause', syncLabel);
          toggle.addEventListener('click', function () {
            video.dataset.userPaused = String(!video.paused);
            video.dataset.userPlayed = 'true';
            playVideo(slide, true);
          });
        });
        document.addEventListener('visibilitychange', function () { playVideo(slides[i], true); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            heroVisible = entries[0].isIntersecting;
            playVideo(slides[i], true);
          }).observe(root);
        } else { playVideo(slides[0], true); }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbv2-video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }
    function play(video) {
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    ready(function () {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      document.querySelectorAll('[data-bbvh]').forEach(function (root) {
        var node = root.querySelector('[data-bbvh-clips]');
        if (!node) return;
        var clips = [];
        try { clips = JSON.parse(node.textContent); } catch (e) { return; }
        if (!clips.length) return;
        var deck = root.querySelector('.bbvh__deck');
        var prev = root.querySelector('.bbvh__slot.is-prev video');
        var main = root.querySelector('.bbvh__slot.is-main video');
        var next = root.querySelector('.bbvh__slot.is-next video');
        var i = 0;
        var locked = false;
        var ignoreClick = false;
        var slideMs = 620;
        var ease = 'cubic-bezier(.22, .61, .36, 1)';
        function at(n) {
          return clips[(n + clips.length) % clips.length];
        }
        function load(video, src) {
          if (!video || !src) return;
          if (video.getAttribute('src') !== src) {
            video.src = src;
            video.load();
          }
          play(video);
        }
        function render() {
          load(prev, at(i - 1));
          load(main, at(i));
          load(next, at(i + 1));
        }
        function resetDeck(animate) {
          if (!deck) return;
          deck.style.transition = animate ? 'transform .4s ' + ease : 'none';
          deck.style.transform = 'translate3d(0,0,0)';
        }
        function go(step) {
          if (locked || !step || !deck) return;
          locked = true;
          ignoreClick = true;
          var shift = (step > 0 ? -22 : 22) + '%';
          deck.style.transition = 'transform ' + slideMs + 'ms ' + ease;
          deck.style.transform = 'translate3d(' + shift + ',0,0)';
          var finished = false;
          function finish() {
            if (finished) return;
            finished = true;
            deck.removeEventListener('transitionend', onEnd);
            i = (i + step + clips.length) % clips.length;
            render();
            resetDeck(false);
            void deck.offsetWidth;
            locked = false;
            setTimeout(function () { ignoreClick = false; }, 80);
          }
          function onEnd(e) {
            if (e.target !== deck) return;
            finish();
          }
          deck.addEventListener('transitionend', onEnd);
          setTimeout(finish, slideMs + 80);
        }
        root.querySelectorAll('[data-bbvh-dir]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (ignoreClick) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            go(Number(btn.getAttribute('data-bbvh-dir')) || 1);
          });
        });

        if (deck) {
          var startX = 0;
          var startY = 0;
          var tracking = false;
          var axis = null;
          var dragged = false;
          function point(e) {
            var t = e.changedTouches && e.changedTouches[0];
            return t || e;
          }
          deck.addEventListener('touchstart', function (e) {
            if (locked || !e.touches || e.touches.length !== 1) return;
            var p = e.touches[0];
            startX = p.clientX;
            startY = p.clientY;
            tracking = true;
            axis = null;
            dragged = false;
            deck.style.transition = 'none';
          }, { passive: true });
          deck.addEventListener('touchmove', function (e) {
            if (!tracking || locked) return;
            var p = e.touches[0];
            var dx = p.clientX - startX;
            var dy = p.clientY - startY;
            if (!axis) {
              if (Math.abs(dx) < 12 && Math.abs(dy) < 12) return;
              axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
              if (axis === 'y') tracking = false;
            }
            if (axis !== 'x') return;
            if (e.cancelable) e.preventDefault();
            dragged = true;
            var drag = Math.max(-72, Math.min(72, dx * 0.28));
            deck.style.transform = 'translate3d(' + drag + 'px,0,0)';
          }, { passive: false });
          deck.addEventListener('touchend', function (e) {
            if (!tracking && axis !== 'x') {
              axis = null;
              return;
            }
            tracking = false;
            if (axis !== 'x') {
              axis = null;
              resetDeck(true);
              return;
            }
            axis = null;
            var dx = point(e).clientX - startX;
            if (dragged) {
              ignoreClick = true;
              setTimeout(function () { ignoreClick = false; }, 160);
            }
            if (dragged && Math.abs(dx) >= 64) {
              go(dx < 0 ? 1 : -1);
            } else {
              resetDeck(true);
            }
          });
          deck.addEventListener('touchcancel', function () {
            tracking = false;
            axis = null;
            if (!locked) resetDeck(true);
          });
        }
        render();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbv2-video-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
      else fn();
    }
    ready(function () {
      document.querySelectorAll('[data-bbvr]').forEach(function (root) {
        var node = root.querySelector('[data-bbvr-clips]');
        var rail = root.querySelector('[data-bbvr-rail]');
        if (!node || !rail) return;
        var clips = [];
        try { clips = JSON.parse(node.textContent); } catch (e) { return; }
        clips.forEach(function (clip) {
          var src = typeof clip === 'string' ? clip : clip.src;
          var card = document.createElement('div');
          card.className = 'bbvr__card';
          var video = document.createElement('video');
          video.className = 'bbvr__video';
          video.muted = true;
          video.playsInline = true;
          video.loop = true;
          video.preload = 'none';
          if (clip && clip.poster) video.poster = clip.poster;
          video.setAttribute('aria-label', 'Creator video');
          video.dataset.src = src;
          card.appendChild(video);
          rail.appendChild(card);
        });
        var videos = rail.querySelectorAll('.bbvr__video');
        var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var toggle = root.querySelector('[data-bbvr-toggle]');
        function playVisible() {
          var railRect = rail.getBoundingClientRect();
          videos.forEach(function (video) {
            var rect = video.parentElement.getBoundingClientRect();
            var on = rect.right > railRect.left && rect.left < railRect.right && rect.bottom > 0 && rect.top < window.innerHeight && !document.hidden;
            if (on && !video.getAttribute('src')) { video.preload = 'metadata'; video.src = video.dataset.src; }
            if (on && !paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else { video.pause(); }
          });
          if (toggle) toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        }
        if (toggle) toggle.addEventListener('click', function () { paused = !paused; playVisible(); });
        rail.addEventListener('scroll', playVisible, { passive: true });
        window.addEventListener('resize', playVisible, { passive: true });
        document.addEventListener('visibilitychange', playVisible);
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(playVisible);
          videos.forEach(function (video) { observer.observe(video.parentElement); });
        } else { window.addEventListener('scroll', playVisible, { passive: true }); }
        playVisible();

        root.querySelectorAll('[data-bbvr-dir]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var step = (rail.querySelector('.bbvr__card') || {}).offsetWidth || 240;
            rail.scrollBy({ left: (Number(btn.getAttribute('data-bbvr-dir')) || 1) * (step + 12), behavior: 'smooth' });
          });
        });

        var dragging = false;
        var startX = 0;
        var startScroll = 0;
        rail.addEventListener('pointerdown', function (e) {
          dragging = true;
          startX = e.clientX;
          startScroll = rail.scrollLeft;
          rail.classList.add('is-dragging');
          rail.setPointerCapture(e.pointerId);
        });
        rail.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          rail.scrollLeft = startScroll - (e.clientX - startX);
        });
        function stopDrag() {
          dragging = false;
          rail.classList.remove('is-dragging');
        }
        rail.addEventListener('pointerup', stopDrag);
        rail.addEventListener('pointercancel', stopDrag);

      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
